import './inbox_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.YoutubeContentView extends Monitoring.Views.SocialContents.InboxContentView
